
<div class="form-container">
  <h2>Zmiana danych logowania</h2>
  <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
    <!-- Name Field -->


    <!-- Email Field (Read-Only) -->
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" readonly />
    </mat-form-field>
    <div> (Zmiana email możliwa jest tylko poprzez kontakt z konsultantem ZGranego Grona)</div>

    <div class="password-group card">
      <div class="password-group-label">
        <p>Wpisz hasło jeśli chcesz ustawić nowe</p>
        <p>Hasło musi być dłuższe niż 8 znaków</p>
      </div>
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Hasło</mat-label>
        <input matInput type="password" formControlName="password" />
        @if (registerForm.get('password')?.hasError('required')) {
          <mat-error>
            Hasło jest wymagane
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Powtórz hasło</mat-label>
        <input matInput type="password" formControlName="repwd" />
        @if (registerForm.get('repwd')?.hasError('required')) {
          <mat-error>
            Powtórzenie hasła jest wymagane
          </mat-error>
        }
        @if (registerForm.get('repwd')?.hasError('passwordsMismatch')) {
          <mat-error>
            Hasła nie są zgodne
          </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Submit Button -->
    <button class="custom-button" color="primary" type="submit" [disabled]="registerForm.invalid">
      Zmień hasło
    </button>
  </form>
</div>
<p></p>